var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-verification-email-sent-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var contact = ref.contact;
var isWhiteLabeled = ref.isWhiteLabeled;
return [_c('account-verification-email-sent-view',{attrs:{"contact":contact,"isWhiteLabeled":isWhiteLabeled}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }